<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    full-width
    max-width="290"
  >
    <template #activator="{ on }">
      <v-text-field
        v-bind="$attrs"
        ref="field"
        :value="date"
        clearable
        prepend-icon="event"
        readonly
        @click:clear="localValue = ''"
        v-on="on"
      />
    </template>
    <v-date-picker
      v-if="menu"
      v-model="localValue"
      :locale="$store.state.languages.iso()"
      first-day-of-week="1"
      :min="min"
      :max="max"
      :readonly="readonly"
      @change="menu = false"
    />
  </v-menu>
</template>

<script>
import { formatDate } from '@/helpers'
export default {
  name: 'DatePicker',
  props: {
    value: {
      type: [String, Date],
      required: false,
      default: '',
    },
    min: {
      type: [String, Date],
      required: false,
      default: null,
    },
    max: {
      type: [String, Date],
      required: false,
      default: null,
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      menu: false,
      // date: ''
    }
  },
  // watch: {
  //   localValue(val) {
  //     console.log('localValue', val)
  //     console.log('formatDate', formatDate(val))
  //     this.date = formatDate(val)
  //     if (this.$refs.field) this.$refs.field.lazyValue = this.date
  //   }
  // },
  computed: {
    localValue: {
      get() {
        return this.value || ''
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    date() {
      return formatDate(this.localValue)
    },
  },
}
</script>
